import { render } from "./PokemonOptions.vue?vue&type=template&id=c410ba3c&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=c410ba3c&scoped=true&lang=css"

import exportComponent from "E:\\Jose Carlos\\Escritorio\\Vue\\05-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c410ba3c"]])

export default __exports__